module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ranking":"Ranking"},"en":{"ranking":"Ranking"}}')
  delete Component.options._Ctor
}
